class HeadlessB2BSCIMClient {
    _networkClient;
    _subscriptionService;
    constructor(_networkClient, _subscriptionService){
        this._networkClient = _networkClient;
        this._subscriptionService = _subscriptionService;
    }
    async createConnection(data) {
        return await this._networkClient.fetchSDK({
            url: '/b2b/scim',
            method: 'POST',
            body: data
        });
    }
    async updateConnection(data) {
        return await this._networkClient.fetchSDK({
            url: `/b2b/scim/${data.connection_id}`,
            method: 'PUT',
            body: data
        });
    }
    async deleteConnection(connectionId) {
        return await this._networkClient.fetchSDK({
            url: `/b2b/scim/${connectionId}`,
            method: 'DELETE'
        });
    }
    async getConnection() {
        return await this._networkClient.fetchSDK({
            url: '/b2b/scim',
            method: 'GET'
        });
    }
    async getConnectionGroups(data) {
        return await this._networkClient.fetchSDK({
            url: '/b2b/scim/groups',
            method: 'POST',
            body: data
        });
    }
    async rotateStart(connectionId) {
        return await this._networkClient.fetchSDK({
            url: `/b2b/scim/rotate/start`,
            method: 'POST',
            body: {
                connection_id: connectionId
            }
        });
    }
    async rotateComplete(connectionId) {
        return await this._networkClient.fetchSDK({
            url: `/b2b/scim/rotate/complete`,
            method: 'POST',
            body: {
                connection_id: connectionId
            }
        });
    }
    async rotateCancel(connectionId) {
        return await this._networkClient.fetchSDK({
            url: `/b2b/scim/rotate/cancel`,
            method: 'POST',
            body: {
                connection_id: connectionId
            }
        });
    }
}

export { HeadlessB2BSCIMClient };
//# sourceMappingURL=HeadlessB2BSCIMClient.mjs.map
